module.exports = __webpack_public_path__ + "amount-failed.png?e66027ec18536d693c773a21166e0432";